import { theme } from "@common/theme/theme"
import React from "react"
import { View } from "react-native"
import { IconButton } from "react-native-paper"

// The two arrows over the steps of the tutor application; the screen gives the row its width (`style`).
export const SliderNavigationM = (props) => {
    const { style, currentIndex, setCurrentIndex, flatListRef, data } = props

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                ...style,
            }}
        >
            <IconButton
                size={20}
                icon={"angle-left"}
                disabled={currentIndex === 0}
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                onPress={() => {
                    if (currentIndex > 0)
                        flatListRef?.current?.scrollToIndex({
                            index: currentIndex - 1,
                        })
                    setCurrentIndex(currentIndex - 1)
                }}
            />

            <IconButton
                size={20}
                icon={"angle-right"}
                disabled={currentIndex === data?.length - 1}
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                onPress={() => {
                    if (currentIndex < data?.length - 1)
                        flatListRef?.current?.scrollToIndex({
                            index: currentIndex + 1,
                        })
                    setCurrentIndex(currentIndex + 1)
                }}
            />
        </View>
    )
}
